import React, { useState } from 'react'
import Pencil from '../icons/Pencil'
import Modal from './Modal'
import UnitModal from './UnitModal'
import { useDispatch } from 'react-redux'
import { UPDATE_UNIT } from '../redux/unitsReducer'
import { Link } from 'react-router-dom'

interface Props {
  unitName: string
  unitDescription: string
  imageUrl: string
  id: string
}

const UnitTile = ({ unitName, unitDescription, imageUrl, id }: Props) => {
  const [openEditModal, setOpenEditModal] = useState(false)
  const dispatch = useDispatch()
  const onEditUnit = ({ name, description, image }: { name: string; description: string; image: string }) => {
    setOpenEditModal(false)
    dispatch(UPDATE_UNIT({ id, name, description, image }))
  }

  return (
    <div className="border p-4 rounded-md shadow-md">
      <Link to={`/units/${id}`}>
        <img src={imageUrl} alt={`${unitName} unit`} className="w-full h-32 object-cover rounded-t-md" />
        <h3 className="text-20 font-semibold mt-2">{unitName}</h3>
        <p className="text-14 text-gray-600">{unitDescription}</p>
      </Link>
      <button
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          setOpenEditModal(true)
        }}
        className="bg-slateGray px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer mt-2">
        <div className="text-white w-5 h-5">
          <Pencil />
        </div>
        <div className="text-14 font-semibold text-white">Edit</div>
      </button>
      <Modal isOpen={openEditModal} toggleModal={() => setOpenEditModal(!openEditModal)}>
        <UnitModal
          onSubmit={onEditUnit}
          image={imageUrl}
          description={unitDescription}
          name={unitName}
          buttonLabel="Update"
        />
      </Modal>
    </div>
  )
}

export default UnitTile
